<div id="map">
    <div id="map-canvas"></div>

    <map-ready-setter marker-clusterer="ctrl.markerClusterer"></map-ready-setter>

    <map-bounds-state-setter map="ctrl.map"></map-bounds-state-setter>

    <map-to-coordinates-pointer map="ctrl.map"></map-to-coordinates-pointer>

    <user-location-marker map="ctrl.map" marker-options="::ctrl.markerOptions"
                          ng-if="ctrl.searchedPlaceCoordinates"></user-location-marker>

    <highlighted-bounds map="ctrl.map"></highlighted-bounds>

    <shop-markers
            open-shop-details-url-in-new-window="ctrl.openShopDetailsUrlInNewWindow"
            shop-type="ctrl.shopType"
            marker-clusterer="ctrl.markerClusterer"
            ng-if="ctrl.shopType">
    </shop-markers>

    <info-window map="ctrl.map" ng-if="ctrl.toggleInfoWindow"></info-window>

    <shops-in-bounds map="ctrl.map" marker-clusterer="ctrl.markerClusterer"></shops-in-bounds>

    <shop-marker-clicker marker-clusterer="ctrl.markerClusterer"></shop-marker-clicker>

    <directions-setter
            searched-place-coordinates="ctrl.searchedPlaceCoordinates"
            clicked-marker-coordinates="ctrl.clickedMarkerCoordinates"
            directions-display="ctrl.directionsDisplay"
            directions-service="ctrl.directionsService"
            ng-if="ctrl.searchedPlaceCoordinates && ctrl.clickedMarkerCoordinates && ctrl.toggleInfoWindow">
    </directions-setter>

    <shop-highlighter map="ctrl.map" marker-clusterer="ctrl.markerClusterer"
                      ng-if="ctrl.highlightShopOnMapByPosFromUrl"></shop-highlighter>

    <div class="legend"
         ng-if="ctrl.shopType.typeFilters.indexOf(ctrl.shopTypesServ.getTypeOmMerchant()) === -1">
        <div class="legend__item">
            <img class="legend__img"
                 src="assets/map/markers/poi-or.svg"
                 alt="Orange shop">
            <span class="legend__text">Orange shop</span>
        </div>

        <div class="legend__item">
            <img class="legend__img"
                 src="assets/map/markers/poi-yl.svg"
                 alt="Orange store">
            <span class="legend__text">Orange store</span>
        </div>
    </div>

    <div class="legend"
         ng-if="ctrl.shopType.typeFilters.indexOf(ctrl.shopTypesServ.getTypeOmMerchant()) > -1">
        <div class="legend__item">
            <img class="legend__img"
                 src="assets/map/shop-icons/iconFashion.png"
                 srcset="assets/map/shop-icons/iconFashion.png 1x, assets/map/shop-icons/iconFashion@2x.png 2x, assets/map/shop-icons/iconFashion@3x.png 3x"
                 alt="Mod&#259;">
            <span class="legend__text">Mod&#259;</span>
        </div>

        <div class="legend__item">
            <img class="legend__img"
                 src="assets/map/shop-icons/iconSupermarket.png"
                 srcset="assets/map/shop-icons/iconSupermarket.png 1x, assets/map/shop-icons/iconSupermarket@2x.png 2x, assets/map/shop-icons/iconSupermarket@3x.png 3x"
                 alt="Supermarket">
            <span class="legend__text">Supermarket</span>
        </div>

        <div class="legend__item">
            <img class="legend__img"
                 src="assets/map/shop-icons/iconRestaurant.png"
                 srcset="assets/map/shop-icons/iconRestaurant.png 1x, assets/map/shop-icons/iconRestaurant@2x.png 2x, assets/map/shop-icons/iconRestaurant@3x.png 3x"
                 alt="Restaurante">
            <span class="legend__text">Restaurante</span>
        </div>

        <div class="legend__item">
            <img class="legend__img" src="assets/map/shop-icons/iconFreetime.png"
                 srcset="assets/map/shop-icons/iconFreetime.png 1x, assets/map/shop-icons/iconFreetime@2x.png 2x, assets/map/shop-icons/iconFreetime@3x.png 3x"
                 alt="Timp liber">
            <span class="legend__text">Timp liber</span>
        </div>

        <div class="legend__item">
            <img class="legend__img" src="assets/map/shop-icons/iconHealth.png"
                 srcset="assets/map/shop-icons/iconHealth.png 1x, assets/map/shop-icons/iconHealth@2x.png 2x, assets/map/shop-icons/iconHealth@3x.png 3x"
                 alt="S&#259;n&#259;tate">
            <span class="legend__text">S&#259;n&#259;tate</span>
        </div>

        <div class="legend__item">
            <img class="legend__img" src="assets/map/shop-icons/iconServices.png"
                 srcset="assets/map/shop-icons/iconServices.png 1x, assets/map/shop-icons/iconServices@2x.png 2x, assets/map/shop-icons/iconServices@3x.png 3x"
                 alt="Servicii">
            <span class="legend__text">Servicii</span>
        </div>

        <div class="legend__item">
            <img class="legend__img" src="assets/map/shop-icons/iconElectronics.png"
                 srcset="assets/map/shop-icons/iconElectronics.png 1x, assets/map/shop-icons/iconElectronics@2x.png 2x, assets/map/shop-icons/iconElectronics@3x.png 3x"
                 alt="Electronice">
            <span class="legend__text">Electronice</span>
        </div>

        <div class="legend__item">
            <img class="legend__img" src="assets/map/shop-icons/iconGeneral.png"
                 srcset="assets/map/shop-icons/iconGeneral.png 1x, assets/map/shop-icons/iconGeneral@2x.png 2x, assets/map/shop-icons/iconGeneral@3x.png 3x"
                 alt="Magazin">
            <span class="legend__text">Magazin</span>
        </div>
    </div>
</div>
